module.exports = __webpack_public_path__ + "static/Oracle_logo-1874aff5337f8f4dd426ba4dc666dd3e.png";